export default __webpack_public_path__ + "media/src/usersite/images/header/history-ff7e7a0439f573b94cc0c3f9f5fab4e1.png";